import React from "react";
import styles from "./validation-message.module.css";
import { UseFormRegister, FieldErrors } from "react-hook-form";

interface ValidationMessageProp {
    name: string;
    value: any;
    errors: FieldErrors;
    register: UseFormRegister<any>;
    message: string;
    min?: number;
}

const RequiredMessage = ({ name, value, errors, register, message }: ValidationMessageProp) => {
    return (
        <>
            <input
                className="hidden"
                {...register(name, { required: true, minLength: 1 })}
                value={value}
                readOnly
            />
            {errors[name] && <p className={styles.message}>{message}</p>}
        </>
    );
};

const MinValidateMessage = ({ name, value, errors, register, message, min }: ValidationMessageProp) => {
    return (
        <>
            <input
                className="hidden"
                {...register(name, { required: true, minLength: 1, min: min ?? 1 })}
                value={value}
                readOnly
            />
            {errors[name] && <p className={styles.message}>{message}</p>}
        </>
    );
};

export { RequiredMessage, MinValidateMessage };
